// @ts-nocheck legacy file transformed to TS
import React from 'react'
import { Img } from 'react-image'
import svg from '../../assets/warning.svg'

export default function Warning({ style }) {
  return <Img src={svg} style={style} />
}
